import { Component } from '@angular/core';
import { OptionsComponent } from '../../components/options/options';
import { PopoverController } from 'ionic-angular';

@Component({
    selector: 'page-corte',
    templateUrl: 'corte.html',
})
export class CortePage {
    public analytic: boolean = true;

    constructor(private _popoverCtrl: PopoverController) { }

    public showOptions(ev: any): void {
        let reactions = this._popoverCtrl.create(OptionsComponent, { analytic: this.analytic });

        reactions.onWillDismiss(analytic => {
            if (analytic != null)
                this.analytic = analytic;
        });

        reactions.present({ ev: ev });
    }
}


// WEBPACK FOOTER //
// ./src/pages/corte/corte.ts